<style type="text/css" lang="stylus" scoped>
  @import '../config/var-css'
dialogW = 540
.dialog-bg
    position fixed
    background-color $black
    opacity 0.4
    top 0
    left 0
    right 0
    bottom 0
    z-index 900
.dialog
    position fixed
    top 30%
    left 50%
    background-color rgba(255, 255, 255, 0.9)
    border-radius rem(24)
    width rem(dialogW)
    margin-left rem(dialogW * -0.5)
    padding rem(50)
    z-index 901
    .dialog-footer
        text-align center
        .btn
            box-shadow none !important
            padding rem(30) 0
            width 100%
        .rightH
            border-top-right-radius 0
            border-bottom-right-radius 0
    .iknow
        font-size $font-size-base
        color $link-color
        border 1px solid $link-color
        border-radius rem(10)
        background-color $white
        padding rem(20) rem(30)
    .btns
        display table
        width 100%
        height rem(80)
        line-height rem(80)
        margin-bottom rem(30 * -1)
        .btn-container
            display table-cell
            a
                display block
    .dialog-split
        border-top 1px solid #ddd
        margin-left rem(30 * -1)
        margin-right rem(30 * -1)
.dialog-common
    padding 0
    .dialog-body
        padding rem(50) rem(30)
        text-align center
        p
            font-size $font-size-large
            color #222
    .dialog-footer
        a
            color $link-color
            font-size $font-size-base
            line-height $font-size-base
    .btn-confirm
        overflow hidden
        .btn-confirm-inner
            width 101%
            clearfix()
            .btn
                width rem(dialogW / 2)
                float left
                display block
.dialog-toast
    z-index 902
    position fixed
    top 0
    width 100%
    max-width rem(750)
    .dialog-toast-bg
        z-index 903
        position absolute
        top 0
        bottom 0
        width 100%
        left 0
        right 0
        background-color #272727
        opacity 0.76
    .dialog-toast-body
        z-index 904
        position relative
        display table
        width 100%
        padding rem(37) rem(30)
        box-sizing border-box
        .dialog-toast-icon
            display table-cell
            width rem(66)
            vertical-align middle
            img
                display block
                width 100%
                text-align center
        .dialog-toast-content
            vertical-align middle
            display table-cell
            margin 0 rem(22) 0 rem(66)
            padding-left rem(28)
            color $white
            text-align left
            .content-title
                font-size $font-size-h6
        .dialog-toast-close
            display table-cell
            width rem(22)
            vertical-align middle
            img
                display block
                width 100%
                text-align center
.fadeOut-leave
    animation fadeOut .5s
.dialog-footer.topH
    border-top 1px solid #DCDCDC
    background none
.dialog-bottom
    .dialog
        left rem(40)
        right rem(40)
        margin 0
        bottom rem(40)
        background-color transparent
        top auto
        width calc(100% - 1.0666666666666667rem)
    .dialog-body
        margin-bottom rem(20)
        background-color rgba(255,255,255,0.9)
        padding rem(30)
        border-radius rem(24)
    .dialog-footer
        background-color rgba(255,255,255,0.9)
        border-radius rem(24)
.dialog-close
    position absolute
    width rem(26)
    height rem(26)
    background url('../assets/icon-x.png') 50% 50% no-repeat transparent
    background-size rem(26) rem(26)
    right rem(30)
    top rem(30)
</style>
<template>
    <div :class="{'dialog-bottom': bottom}">
        <template v-if="_confirm">
            <div v-if='isShow'>
                <div class="dialog-bg">
                </div>
                <div class="dialog dialog-common">
                    <div class="dialog-body">
                        <slot>
                            <p v-html='content'></p>
                        </slot>
                    </div>
                    <div class="dialog-footer btn-confirm topH">
                        <div class="btn-confirm-inner">
                            <a class="btn rightH font-pfc-medium" href='javascript:;' @click.stop.prevent='ok'>
                                <slot name="btn-ok">确定</slot>
                            </a>
                            <a class="btn font-pfc-medium" href='javascript:;' @click='cancel'>
                                <slot name="btn-cancel">取消</slot>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="_toast">
            <div class="dialog-toast animated" v-if='isShow' transition="fadeOut">
                <div class="dialog-toast-body">
                    <slot>
                        <div class="dialog-toast-icon">
                            <img src="../assets/icon-dialog-warn.png">
                        </div>
                        <div class="dialog-toast-content">
                            <p class="content-title font-pfc-medium">错误</p>
                            <p v-html='content'></p>
                        </div>
                        <div class="dialog-toast-close">
                            <img src="../assets/icon-dialog-close.png" @click="hide">
                        </div>
                    </slot>
                </div>
                <div class="dialog-toast-bg"></div>
            </div>
        </template>
        <template v-if="_alert">
            <div v-if='isShow'>
                <div class="dialog-bg">
                </div>
                <div class="dialog dialog-common">
                    <template v-if="closeable">
                        <i class="dialog-close" @click="closeHandler"></i>
                    </template>
                    <div class="dialog-body">
                        <slot>
                            <p v-html='content'></p>
                        </slot>
                    </div>
                    <div class="dialog-footer btn-dialog topH">
                        <a class="btn font-pfc-medium" href='javascript:;' v-on:click.stop.prevent='iknow'>
                            <template v-if="!bottom"><slot name="btn-iknow">知道了</slot></template>
                            <template v-if="bottom">取消</template>
                        </a>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="_custom">
            <div v-if="isShow">
                <div class="dialog-bg"></div>
                <div class="dialog dialog-common">
                    <slot></slot>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/javascript">
    export default {
        props: {
            bottom: {
                type: Boolean,
                default: false
            },
            model: {
                type: String,
                require: true,
                default: 'alert'
            },
            closeable: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                _tss: null,
                isShow: false,
                content: '',
                cb: function () {}
            };
        },
        computed: {
            _confirm () {
                return this.model.toLowerCase() == 'confirm';
            },
            _alert () {
                return this.model.toLowerCase() == 'alert';
            },
            _toast () {
                return this.model.toLowerCase() == 'toast';
            },
            _custom () {
                return this.model.toLowerCase() == 'custom';
            }
        },
        methods: {
            alert (text, cb) {
                this.content = text;
                cb && (this.cb = cb);
                this.show();
            },
            confirm (text, cb) {
                if (typeof text == 'function') {
                    cb = text;
                    text = '';
                }
                this.content = text;
                cb && (this.cb = cb);
                this.show();
            },
            toast (text, cb) {
                this.content = text;
                cb && (this.cb = cb);
                if (this.isShow) {
                    clearTimeout(this._tss);
                    this._tss = setTimeout(() => {
                        this.hide();
                        this.cb();
                    }, 3000);
                    return;
                }
                this.show();
                if (!this._tss) {
                    this._tss = setTimeout(() => {
                        this.hide();
                        this.cb()
                    }, 3000);
                }
            },
            show (cb) {
                cb && (this.cb = cb);
                this.isShow = true;
            },
            hide () {
                if (this._tss) {
                    clearTimeout(this._tss);
                    this._tss = null;
                }
                this.isShow = false;
            },
            iknow () {
                this.hide();
                this.content = '';
                this.cb({
                    action: 'iknow'
                });
            },
            ok () {
                this.hide();
                this.cb(true);
            },
            cancel () {
                this.hide();
                this.cb(false);
            },
            closeHandler () {
                this.hide();
                this.cb({
                    action: 'close'
                });
            }
        }
    }
</script>
